// extracted by mini-css-extract-plugin
export default {"button":"bdO8hEMcWOVF_unsjt9R"};